// extracted by mini-css-extract-plugin
module.exports = {"content":"DailyIframe_content__1cTA6","wrapper":"DailyIframe_wrapper__2alfe"};